import React from 'react';

import { Box, Stack, Typography } from '@mui/material';

interface Props {
  description: string;
  title: string;
}

export default function EgsSectionHeading({ description, title }: Props) {
  return (
    <Box sx={{ px: 3, pt: 3, pb: 2 }}>
      <Stack spacing={0.5}>
        <Typography fontWeight={700} variant="subtitle1">
          {title}
        </Typography>
        <Typography color="text.secondary" variant="body2">
          {description}
        </Typography>
      </Stack>
    </Box>
  );
}
